// extracted by mini-css-extract-plugin
export default {"container":"ymNN8efFBX2gNsIpfZw0","body":"hV2Tp9EXJqN9l10AFb1J","error":"OXkwj9wZ4PO1819tCyqI","alternatives":"Gv9pkOmwgle1eCdUnczn"};